module.exports = __webpack_public_path__ + "static/media/bird2.e8dd1a19.png";